// Response shapes for the conductor scheduling endpoints, mirroring
// merge-backend's AccountSyncStatus / TenantSchedulingConfig app models.

export interface AccountSyncStatus {
  id: string;
  organization_id: string;
  linked_account_id: string;
  /** Resolved from the local DB by the API layer; conductor only stores the id. */
  linked_account_name: string | null;
  tenant_id: string | null;
  category: string | null;
  /** Backend-resolved policy from billing and customer settings. Read-only. */
  speed: string;
  /** The account-level admin override, null when unset. */
  speed_override: string | null;
  /** The org-level override covering this account, null when unset. Read-only here. */
  organization_speed_override: string | null;
  /**
   * Resolved by conductor as account override > org override > policy speed.
   * Rendered as given, never recomputed in the UI.
   */
  effective_speed: string;
  /** Free-text mirror of the backend linked account status. Read-only. */
  status: string;
  conductor_scheduled: boolean;
  modified_at: string | null;
}

// A durable per-organization row, not a bulk write. It covers every linked
// account in the org without its own override, including ones linked later.
export interface OrganizationSyncSpeedOverride {
  id: string | null;
  organization_id: string;
  speed: string;
  modified_at: string | null;
}

export interface TenantSchedulingConfig {
  id: string | null;
  /** The tenant identifier from the third-party provider, not a Merge environment. */
  tenant_id: string;
  max_concurrency: number;
  modified_at: string | null;
}

export const SPEED_OPTIONS = [
  { value: "ACCOUNT_SYNC_SPEED_FAST", label: "Fast" },
  { value: "ACCOUNT_SYNC_SPEED_DAILY", label: "Daily" },
  { value: "ACCOUNT_SYNC_SPEED_NONE", label: "None" },
];

export const speedLabel = (speed: string): string =>
  SPEED_OPTIONS.find((option) => option.value === speed)?.label ??
  speed.replace(/^ACCOUNT_SYNC_SPEED_/, "");
